import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { DeviceChangeDetailsDrawer } from '../../components/device-change-details-drawer';
import { useProvisioningDeviceChangeDetailsPageVM } from './useProvisioningDeviceChangeDetailsPage.vm';
import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';

export function ProvisioningDeviceChangeDetailsPage(): ReactNode {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.DEPLOYMENT, ALL_LNGS_NAMESPACES.COMMON]);

  const {
    deviceChangesByIdQuery,
    statusData,
    targetDeviceIdItem,
    targetDeviceGeneralItems,
    errorMessage,
    deviceCallQuery,
    deviceCallLogs,
    parameterOutputListModal,
    canShowParameterOutputSection,
  } = useProvisioningDeviceChangeDetailsPageVM({ t });

  return (
    <>
      <DeviceChangeDetailsDrawer
        targetDeviceGeneralItems={targetDeviceGeneralItems}
        deviceChangesByIdQuery={deviceChangesByIdQuery}
        targetDeviceIdItem={targetDeviceIdItem}
        statusData={statusData}
        errorMessage={errorMessage}
        t={t}
        isDeviceCallLogsLoading={deviceCallQuery?.isLoading}
        deviceCallLogs={deviceCallLogs}
        canShowParameterOutputSection={canShowParameterOutputSection}
      />
      {parameterOutputListModal}
    </>
  );
}
